import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import pickupLocationVehicleAPI from '@infrastructure/pickup-location-vehicle-api';
export const createPickupLocationVehicleAsync = createAsyncThunk('pickupLocationVehicle/create', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationVehicleAPI.createPickupLocationVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePickupLocationVehicleAsync = createAsyncThunk('pickupLocationVehicle/update', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationVehicleAPI.updatePickupLocationVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVehiclesByPickupLocationIdAsync = createAsyncThunk('pickupLocationVehicle/getByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationVehicleAPI.getVehiclesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllVehiclesByPickupLocationIdAsync = createAsyncThunk('pickupLocationVehicle/getAllByPickupLocationId', async ({ pickupLocationId, searchString }, { rejectWithValue }) => {
    try {
        const response = await pickupLocationVehicleAPI.getAllVehiclesByPickupLocationId(pickupLocationId, searchString);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVehicleByIdAsync = createAsyncThunk('pickupLocationVehicle/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await pickupLocationVehicleAPI.getVehicleById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePickupLocationVehicleAsync = createAsyncThunk('pickupLocationVehicle/delete', async (id, { rejectWithValue }) => {
    try {
        await pickupLocationVehicleAPI.deleteVehicle(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
